"use strict";

var _classCallCheck = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PromiseInspection =
/*#__PURE__*/
function () {
  function PromiseInspection(args) {
    _classCallCheck(this, PromiseInspection);

    this._value = args.value;
    this._error = args.error;
  }

  _createClass(PromiseInspection, [{
    key: "value",
    value: function value() {
      return this._value;
    }
  }, {
    key: "reason",
    value: function reason() {
      return this._error;
    }
  }, {
    key: "isRejected",
    value: function isRejected() {
      return !!this._error;
    }
  }, {
    key: "isFulfilled",
    value: function isFulfilled() {
      return !!this._value;
    }
  }]);

  return PromiseInspection;
}();

exports.PromiseInspection = PromiseInspection;